module.exports = __webpack_public_path__ + "img/freelancer-light.4b79a114.png";